import { createFileRoute } from "@tanstack/react-router";

import { NeedHelpScreen } from "@/modules/support/screens/NeedHelpScreen";

export const Route = createFileRoute("/embed/support/")({
  component: NeedHelpScreen,
});
